export function cleanNullItem(obj: any): void {
    if (Array.isArray(obj)) {
        obj.forEach(function (v) {
            cleanNullItem(v);
        });
    } else if (obj && typeof obj === 'object') {
        Object.keys(obj).forEach(
            function (key) {
                if (obj[key] == null) {
                    delete obj[key];
                }
            }
        );
    }
}

interface DeepCopyOptions {
    hash?: WeakMap<object, any>;
}

export function deepCopy<T>(data: T, hash: WeakMap<object, any> = new WeakMap()): T {
    if (typeof data !== 'object' || data === null) {
        throw new TypeError('传入参数不是对象');
    }
    
    // 判断传入的待拷贝对象的引用是否存在于hash中
    if (hash.has(data as object)) {
        return hash.get(data as object);
    }
    
    let newData: any;
    
    // 处理数组
    if (Array.isArray(data)) {
        newData = [...data];
    }
    // 处理Set
    else if (data instanceof Set) {
        newData = new Set([...data]);
    }
    // 处理Map
    else if (data instanceof Map) {
        newData = new Map([...data]);
    }
    // 处理普通对象
    else if (typeof data === 'object') {
        newData = {};
        // 将这个待拷贝对象的引用存于hash中
        hash.set(data as object, newData);
    }
    
    // 递归复制属性
    const dataKeys = Object.keys(data as object);
    dataKeys.forEach(value => {
        const currentDataValue = (data as any)[value];
        
        // 基本数据类型的值和函数直接赋值拷贝
        if (typeof currentDataValue !== "object" || currentDataValue === null) {
            newData[value] = currentDataValue;
        } else {
            // 递归拷贝对象类型的属性
            newData[value] = deepCopy(currentDataValue, hash);
        }
    });
    
    return newData as T;
}